module.exports = __webpack_public_path__ + "media/src/images/header/icon-search-e4e3ee1e52c468c44ad61badd2e07679.svg";